import { DeliveryDiscountWriteCampaignProps } from 'apis/restaurant-api/merchant-admin/campaigns/api';
import { DiscountValue } from 'apis/restaurant-api/merchant-admin/campaigns/types';

import { transformCommonFormFieldsToApi } from './transformCommonFormFieldsToApi';
import { DeliveryDiscountFormValues } from '../../types';

export type TransformDeliveryDiscountFormToApiValues = DeliveryDiscountFormValues & {
  deliveryDiscount: DiscountValue;
  currency: Currency;
  merchantId: string;
  venueIds: string[];
};

export const transformDeliveryDiscountFormToApi = (
  values: TransformDeliveryDiscountFormToApiValues,
): DeliveryDiscountWriteCampaignProps => ({
  ...transformCommonFormFieldsToApi(values),
  maxDeliveryDistance: values.maxDeliveryDistance,
  campaignType: values.campaignType,
  deliveryDiscount: values.deliveryDiscount,
});
